// Logo-Slider
document.querySelectorAll('.logo-slider__contain .glider').forEach(el => {
	new Glider(el, {
		slidesToShow: 2,
		slidesToScroll: 1,
		draggable: true,
		rewind: true,
		arrows: {
			prev: el.closest('.logo-slider__contain').querySelector('.logo-slider__prev'),
			next: el.closest('.logo-slider__contain').querySelector('.logo-slider__next'),
		},
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			}
		]
	});
});
